<template>
  <div class="content-block">
    <div class="content-block-title">{{$lang.messages.remote.title}} </div>
    <div v-if="isPremium" class="feature-lock flex-between mb-3" :class="{locked: isLocked}">
      <div class="content-block-subtitle">{{$lang.messages.remote.remote_lock}}</div>
      <div class="flex flex-v-center">
        <div class="lock-image">
          <img v-if="kidsMode" src="../assets/img/locked-icon.svg" alt="locked">
          <img v-if="!kidsMode" src="../assets/img/unlocked-icon.svg" alt="unlocked">
        </div>
        <div>
          <span class="lock-label" :class="{locked: kidsMode}">{{kidsMode ? 'Lock' : 'Unlock'}}</span>
          <p class="feature-text text-muted">{{$lang.messages.remote.description}}</p>
        </div>
      </div>
      <div class="flex-v-center remote-go-settings-block">
        <button class="btn btn-outline" @click="openMenuItem('Settings')">{{$lang.messages.statistic.go_settings}}</button>
      </div>
    </div>
    <div class="content-block-subtitle">{{$lang.messages.remote.features.title}}</div>
    <div class="row">
      <div class="col-md-4" v-for="feature in features" :key="feature.id">
        <div class="feature">
          <div class="feature-icon">
            <img :src="imgUrl(feature.icon)" alt="icon">
          </div>
          <div class="feature-title">{{feature.title}}</div>
          <div class="feature-text text-muted">{{feature.text}}</div>
        </div>
      </div>
    </div>
    <div v-if="!isPremium">
      <p class="text-center text-bold mt-1 mb-1">
        {{$lang.messages.remote.features.premium}}
      </p>
      <p class="text-center">
        <button class="btn btn-premium" @click="openMenuItem('Premium')">{{$lang.messages.get_premium}}</button>
      </p>
    </div>
  </div>
</template>

<script>
const images = require.context('../assets/img/features/', false, /\.svg$/)
export default {
  name: 'Remote',
  props: ['isPremium', 'isLocked', 'todayDailyLimit', 'kidsMode'],
  data: function () {
    return {
      showOnlyPremiumModal: false,
      locked: this.isLocked,
      features: [
        {
          id: 1,
          icon: 'feature-1.svg',
          title: this.$lang.messages.remote.features.feature_1_title,
          text: this.$lang.messages.remote.features.feature_1_text
        },
        {
          id: 2,
          icon: 'feature-2.svg',
          title: this.$lang.messages.remote.features.feature_2_title,
          text: this.$lang.messages.remote.features.feature_2_text
        },
        {
          id: 3,
          icon: 'feature-3.svg',
          title: this.$lang.messages.remote.features.feature_3_title,
          text: this.$lang.messages.remote.features.feature_3_text
        }
      ]
    }
  },
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    updateSettings(keyName, value){
      this.$emit('updatesettings', {[keyName]: value})
    },
    openMenuItem (title) {
      this.$emit('openmenuitem', title);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.feature {
  padding: 24px;
  background: #F5F7FB;
  border-radius: 20px;
  height: 100%;

  @include responsive-below($md){
    height: auto;
    margin-bottom: 16px;
  }

  &-icon {
    text-align: center;
  }
  &-title {
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    margin-top: 18px;
    margin-bottom: 16px;
  }

  &-text {
    font-size: 13px;
  }

  &-lock {
    padding: 24px;
    background: #F5F7FB;
    border-radius: 20px;

    @include responsive-below($md) {
      flex-direction: column;
    }

    &-time {
      @include responsive-below($md) {
        margin-bottom: 16px;
      }

      &-select {
        margin-left: 30px;

        @include responsive-below($lg) {
          margin-left: 16px;
        }

        @include responsive-below($md) {
          &.v-select {
            margin-left: 0;
            display: block;
          }
        }
      }
    }

    &.locked {
      background: #EEF0FF;
    }
  }
}

.lock {
  &-image {
    margin-right: 24px;
    min-width: 60px;
  }

  &-label {
    display: inline-block;
    background: #DEE1F9;
    border-radius: 20px;
    padding: 4px 15px;
    color: #515156;
    font-size: 16px;
    margin-bottom: 8px;

    &.locked {
      background: #A294F1;
      color: #fff;
    }
  }
}

@include responsive-below($md){
  .remote-go-settings-block {
    margin-top: 16px;
    justify-content: flex-end;
  }
}

</style>

